export const tooltipItems = [
  {
    block: 'Link',
    shortcut: '[Title](URL)',
  },
  {
    block: 'Heading 1',
    shortcut: '#',
  },
  {
    block: 'Heading 2',
    shortcut: '##',
  },
  {
    block: 'Heading 3',
    shortcut: '###',
  },
  {
    block: 'Blockquote',
    shortcut: '>',
  },
  {
    block: 'Callout',
    shortcut: '>👍',
  },
  {
    block: 'Bulleted List',
    shortcut: '-',
  },
  {
    block: 'Numbered List',
    shortcut: '1.',
  },
  {
    block: 'Check List',
    shortcut: '- [ ]',
  },
  {
    block: 'Code',
    shortcut: '```',
  },
  {
    block: 'Divider',
    shortcut: '---',
  },
  {
    block: 'Image',
    label: 'Image',
    shortcut: '![Alt text](URL)',
  },
  {
    block: 'Recipe',
  },
  {
    block: 'Table',
  },
  {
    block: 'Custom HTML',
  },
  {
    block: 'YouTube',
  },
  {
    block: 'GitHub Gist',
  },
  {
    block: 'PDF',
  },
  {
    block: 'JSFiddle',
  },
  {
    block: 'Iframe',
  },
  {
    block: 'New Content',
    label: 'Reusable Content',
    description: 'The contents of this block will be synced between all pages',
  },
  {
    block: 'Accordion',
  },
  {
    block: 'Cards',
  },
  {
    block: 'Columns',
  },
  {
    block: 'Tabs',
  },
  {
    block: 'Mermaid',
    label: 'Mermaid Diagram',
    description: 'Create diagrams and charts with Mermaid.js',
  },
];
